// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tablewidget_featured__xBDZZ {
  display: flex;
  flex-direction: row;
 flex: 1 1; 
 align-items: center;
 align-content: center; 
  justify-content: space-between;
}

.tablewidget_featuredItem__QfyNm {
  flex: 1 1;
  margin: 0px 20px;
  padding: 30px;
  border-radius: 10px;
  cursor: pointer;

}

.tablewidget_featuredTitle__cDiim{
     display: flex;
    align-items: center;
    justify-content: center; 
    font-size: 20px;
}

.tablewidget_featuredTitleHeader__94WQY{
    font-size: 14px;
}


.tablewidget_featuredTextContainer__Fj2r3{
    margin: 10px 0px;
    display: flexbox;
    align-items: center;
    justify-content:left;
        
}

.tablewidget_featuredText__OmJoH{
    font-size: 50px;
    font-weight: 600;
     display: flex;
    align-items: center;
    justify-content: center; 
    color: var(--hsrcOrange); 
}


.tablewidget_featuredIcon__luR4M{
    font-size: 14px;
    margin-left: 5px;
    color: green;
}

.tablewidget_featuredIcon__luR4M.tablewidget_negative__D0hRn{
    color: red;
}

.tablewidget_featuredSub__lrUUl{
    font-size: 15px;
    color: gray;
     display: flex;
    align-items: center;
    justify-content: center; 
}

.tablewidget_recharts-cartesian-axis-tick__wHChe {    
 font-size:  1px !important;
    font-weight: 200;
}


.tablewidget_recharts-cartesian-axis__kA2KX {
    font-size: 1px !important;
    font-weight: 100;
}


text {
    font-size:  1px ;
    font-weight: 200;
}`, "",{"version":3,"sources":["webpack://./src/components/TableWidget/tablewidget.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;CACpB,SAAO;CACP,mBAAmB;CACnB,qBAAqB;EACpB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;KACK,aAAa;IACd,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;;AAExB;;AAEA;IACI,eAAe;IACf,gBAAgB;KACf,aAAa;IACd,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;KACV,aAAa;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,0BAA0B;IACvB,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".featured {\r\n  display: flex;\r\n  flex-direction: row;\r\n flex: 1; \r\n align-items: center;\r\n align-content: center; \r\n  justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n  flex: 1;\r\n  margin: 0px 20px;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.featuredTitle{\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    font-size: 20px;\r\n}\r\n\r\n.featuredTitleHeader{\r\n    font-size: 14px;\r\n}\r\n\r\n\r\n.featuredTextContainer{\r\n    margin: 10px 0px;\r\n    display: flexbox;\r\n    align-items: center;\r\n    justify-content:left;\r\n        \r\n}\r\n\r\n.featuredText{\r\n    font-size: 50px;\r\n    font-weight: 600;\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n    color: var(--hsrcOrange); \r\n}\r\n\r\n\r\n.featuredIcon{\r\n    font-size: 14px;\r\n    margin-left: 5px;\r\n    color: green;\r\n}\r\n\r\n.featuredIcon.negative{\r\n    color: red;\r\n}\r\n\r\n.featuredSub{\r\n    font-size: 15px;\r\n    color: gray;\r\n     display: flex;\r\n    align-items: center;\r\n    justify-content: center; \r\n}\r\n\r\n.recharts-cartesian-axis-tick {    \r\n font-size:  1px !important;\r\n    font-weight: 200;\r\n}\r\n\r\n\r\n.recharts-cartesian-axis {\r\n    font-size: 1px !important;\r\n    font-weight: 100;\r\n}\r\n\r\n\r\ntext {\r\n    font-size:  1px ;\r\n    font-weight: 200;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featured": `tablewidget_featured__xBDZZ`,
	"featuredItem": `tablewidget_featuredItem__QfyNm`,
	"featuredTitle": `tablewidget_featuredTitle__cDiim`,
	"featuredTitleHeader": `tablewidget_featuredTitleHeader__94WQY`,
	"featuredTextContainer": `tablewidget_featuredTextContainer__Fj2r3`,
	"featuredText": `tablewidget_featuredText__OmJoH`,
	"featuredIcon": `tablewidget_featuredIcon__luR4M`,
	"negative": `tablewidget_negative__D0hRn`,
	"featuredSub": `tablewidget_featuredSub__lrUUl`,
	"recharts-cartesian-axis-tick": `tablewidget_recharts-cartesian-axis-tick__wHChe`,
	"recharts-cartesian-axis": `tablewidget_recharts-cartesian-axis__kA2KX`
};
export default ___CSS_LOADER_EXPORT___;
